import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class, _class2, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "924e8X3znBJJpihF6j6/jEw", "MapCtrl", undefined);

import { _decorator, Component, v3 } from 'cc';
import { E_PlatformType } from './common/EnumBase';
import { App } from './common/manager/App';
import { E_PoolType } from './common/manager/PoolManager';
import { Dove } from './Dove';
import { ItemBase } from './ItemBase';
import { Spikes } from './Spikes';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var MapCtrl = (_dec = ccclass('MapCtrl'), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MapCtrl, _Component);

  function MapCtrl() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_x_cur", 0);

    _defineProperty(_assertThisInitialized(_this), "_interval", 20);

    _defineProperty(_assertThisInitialized(_this), "_y_cur", 0);

    _defineProperty(_assertThisInitialized(_this), "_y_max", 0);

    _defineProperty(_assertThisInitialized(_this), "_rate_collider", 0.2);

    _defineProperty(_assertThisInitialized(_this), "_rate_barrier", 0.2);

    _defineProperty(_assertThisInitialized(_this), "_rate_prop", 0.2);

    _defineProperty(_assertThisInitialized(_this), "_rate_generateC", 0.1);

    _defineProperty(_assertThisInitialized(_this), "_isC_ballRange", false);

    _defineProperty(_assertThisInitialized(_this), "n_map", null);

    _defineProperty(_assertThisInitialized(_this), "colliderArr", []);

    _defineProperty(_assertThisInitialized(_this), "propArr", []);

    _defineProperty(_assertThisInitialized(_this), "_tgIndex", 0);

    _defineProperty(_assertThisInitialized(_this), "_colliderMap", []);

    _defineProperty(_assertThisInitialized(_this), "_colliderCur", []);

    _defineProperty(_assertThisInitialized(_this), "_isGenerateCollider", false);

    _defineProperty(_assertThisInitialized(_this), "_generateTime", 0);

    return _this;
  }

  var _proto = MapCtrl.prototype;

  _proto.init = function init() {
    this._x_cur = App.DataMgr.vSize_game.width;
    this._interval = App.DataMgr.vSize_game.width;
    this._tgIndex = App.DataMgr.tollgateLv;

    this._colliderMap.push(["c_1_0", "c_1_1", "c_1_2"], ["c_2_0", "c_2_1", "c_2_2"], ["c_3_0", "c_3_1", "c_3_2"], ["c_1_0", "c_1_1", "c_1_2", "c_2_0", "c_2_1", "c_2_2", "c_3_0", "c_3_1", "c_3_2", "c_4_0"]);

    if (this._tgIndex < 3) {
      this._colliderCur = this._colliderMap[this._tgIndex];
    } else {
      this._colliderCur = this._colliderMap[3];
    }

    this._rate_barrier = 0.2 * (this._tgIndex * 0.01);
    if (this._rate_barrier > 0.35) this._rate_barrier -= 0.35;
    this._rate_collider = 0.1 * (this._tgIndex * 0.005);
    if (this._rate_collider > 0.25) this._rate_collider = 0.25;
    this._rate_prop = 0.1 * (this._tgIndex * 0.005);
    if (this._rate_prop > 0.35) this._rate_prop = 0.35;
    this._rate_generateC = 0.1 * (this._tgIndex * 0.02);
    if (this._rate_generateC > 0.6) this._rate_generateC = 0.6;
    this.clear();
  };

  _proto.generateItem = function generateItem() {
    // return;
    if (this._x_cur + 5 >= App.DataMgr.mapLen) return;

    if (App.GameCtrl.cam_game.node.position.x + App.DataMgr.vSize_game.width * 2 >= this._x_cur) {
      this._y_max = App.DataMgr.vSize_game.height * 0.7;
      this._y_cur = -App.DataMgr.vBaseSize_game.height / 2;
      var isCreate_ballRange = false; //在球运动方向生成障碍物

      if (this._tgIndex < 3) {
        var num_noise = App.NumHandler.gaussian();

        if (num_noise > 1 || num_noise < -1) {
          this._isC_ballRange = true;
        } else {
          this._isC_ballRange = false;
        }
      } else {
        this._isC_ballRange = Math.random() < this._rate_generateC;
      }

      var y_ball = App.GameCtrl.ball_game.worldPosition.y;
      var y_b_min = y_ball - 1.5;
      var y_b_max = y_ball + 1.5;
      this._generateTime = 0;
      this._isGenerateCollider = false;

      while (this._y_cur < this._y_max) {
        this._generateTime++;
        /**强制生成碰撞体 */

        if (this._isC_ballRange && this._y_cur >= y_b_min && this._y_cur < y_b_max && !isCreate_ballRange) {
          this.generateCollider(true);
          isCreate_ballRange = true;
        } else {
          var num_round = Math.random();

          if (num_round < 0.5) {
            this.generateCollider();
          } else if (num_round < 0.7) {
            this.generateProp();
          } else {
            this.generateBarrier();
          }
        }
      }

      var x_offset = 0;

      if (App.AdCtrl.platformType != E_PlatformType.GameMonetize) {
        x_offset = 8 / (App.DataMgr.tollgateLv + 1);
      }

      this._x_cur += this._interval + App.NumHandler.round_float(6, x_offset);
    }
  }
  /**生成障碍物 */
  ;

  _proto.generateCollider = function generateCollider(isForce) {
    if (isForce === void 0) {
      isForce = false;
    }

    if (this._isGenerateCollider && Math.random() < this._rate_collider || !this._isGenerateCollider && Math.random() < 0.1 * this._generateTime || isForce) {
      this._isGenerateCollider = true;
      var cTypeArr = this._colliderCur;
      var n_c = App.PoolMgr.getItem(cTypeArr[App.NumHandler.round_int(cTypeArr.length)]);
      if (!n_c) return;
      n_c.parent = this.n_map;

      if (n_c.getChildByName("n_c")) {
        var _n_c$getChildByName, _n_c$getChildByName$g;

        (_n_c$getChildByName = n_c.getChildByName("n_c")) === null || _n_c$getChildByName === void 0 ? void 0 : (_n_c$getChildByName$g = _n_c$getChildByName.getComponent(Spikes)) === null || _n_c$getChildByName$g === void 0 ? void 0 : _n_c$getChildByName$g.reset();
      }

      App.GameCtrl.addAutoRecyle(n_c);
      var itemBase = n_c.getComponent(ItemBase); //随机y坐标

      var y_temp = itemBase.size.y / 2;
      /**随机y范围为 c 的高度的两倍 */

      var y_range = 2 * itemBase.size.y;
      var y_aim = App.NumHandler.round_float(y_range, y_temp); //随机x坐标

      var x = this._x_cur + App.NumHandler.round_float(8, -4);
      n_c.setWorldPosition(v3(x, y_aim + this._y_cur, 0));
      this._y_cur += y_aim + y_temp;
      this.colliderArr.push(n_c);
    } else {
      this._y_cur += 3;
    }
  }
  /**生成金币 */
  ;

  _proto.generateCoin = function generateCoin() {}
  /**生成道具 */
  ;

  _proto.generateProp = function generateProp() {
    if (Math.random() < this._rate_prop) {
      var _n_p$getComponent;

      var n_p = App.PoolMgr.getItem(E_PoolType.P_Dove);
      if (!n_p) return;
      n_p.parent = this.n_map;
      this.propArr.push(n_p);
      (_n_p$getComponent = n_p.getComponent(Dove)) === null || _n_p$getComponent === void 0 ? void 0 : _n_p$getComponent.init();
      App.GameCtrl.addAutoRecyle(n_p);
      var itemBase = n_p.getComponent(ItemBase); //随机y坐标

      var h_c = n_p.scale.y;
      var y_temp = h_c / 2 + itemBase.size.y;
      /**随机y范围为 c 的高度的两倍 */

      var y_range = h_c * 2 + itemBase.size.y;
      var y_aim = App.NumHandler.round_float(y_range, y_temp); //随机x坐标

      var x = this._x_cur + App.NumHandler.round_float(10, -5);
      n_p.setWorldPosition(v3(x, y_aim + this._y_cur, 0));
      this._y_cur += y_aim + y_temp;
    } else {
      this._y_cur += 3;
    }
  };

  _proto.generateBarrier = function generateBarrier() {
    if (Math.random() < this._rate_barrier) {
      var n_b = App.PoolMgr.getItem(E_PoolType.B_Rotate);
      if (!n_b) return;
      n_b.parent = this.n_map;
      App.GameCtrl.addAutoRecyle(n_b);
      var itemBase = n_b.getComponent(ItemBase); //随机y坐标

      var h_c = n_b.scale.y;
      var y_temp = h_c / 2 + itemBase.size.y;
      /**随机y范围为 c 的高度的两倍 */

      var y_range = h_c * 2 + itemBase.size.y;
      var y_aim = App.NumHandler.round_float(y_range, y_temp); //随机x坐标

      var x = this._x_cur + App.NumHandler.round_float(10, -5);
      n_b.setWorldPosition(v3(x, y_aim + this._y_cur, 0));
      this._y_cur += y_aim + y_temp;
    } else {
      this._y_cur += 3;
    }
  };

  _proto.clear = function clear() {
    // let allC: Node[] = this.n_map.children;
    // while (allC.length > 1) {
    //     let n_cur: Node = allC.shift()!;
    //     App.PoolMgr.returnItem(n_cur);
    // }
    this.colliderArr = [];
    this.propArr = [];
    this.n_map.destroyAllChildren();
  };

  _proto.reduceCollider = function reduceCollider(uuid) {
    for (var i = 0; i < this.colliderArr.length; i++) {
      if (this.colliderArr[i].uuid == uuid) {
        this.colliderArr.splice(i, 1);
        break;
      }
    }
  };

  _proto.reduceProp = function reduceProp(uuid) {
    for (var i = 0; i < this.propArr.length; i++) {
      if (this.propArr[i].uuid == uuid) {
        this.propArr.splice(i, 1);
        break;
      }
    }
  };

  _proto.removeColliderInView = function removeColliderInView() {
    // let xW_ball: number = App.GameCtrl.ball_game.worldPosition.x;
    // for (let i = 0; i < this.colliderArr.length; i++) {
    //     if (Math.abs(xW_ball - this.colliderArr[i].worldPosition.x) < App.DataMgr.visibleSize.width || this.colliderArr[i].worldPosition.x > xW_ball) {
    //         App.PoolMgr.returnItem(this.colliderArr[i]);
    //     }
    // }
    this.clear();
    this._x_cur = App.GameCtrl.cam_game.node.position.x + App.DataMgr.vSize_game.width;
  };

  _createClass(MapCtrl, null, [{
    key: "I",
    get: function get() {
      if (!MapCtrl._I) {
        MapCtrl._I = new MapCtrl();
      }

      return MapCtrl._I;
    }
    /**最后生成障碍物的 x 基准 */

  }]);

  return MapCtrl;
}(Component), _defineProperty(_class2, "_I", null), _temp)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();